<template>
  <section class="section strategy-section">
    <div class="strategy-overlay"></div>
    <div class="container">
      <div class="strategy-content" data-aos="fade-right">
        <h2>{{ $t("strategy.title") }}</h2>
        <div class="strategy-title-en">{{ $t("strategy.subtitle") }}</div>
        <div class="strategy-divider"></div>
        <p class="strategy-text">{{ $t("strategy.description") }}</p>
      </div>
    </div>
    <div class="floating-elements">
      <div class="float-item" v-for="i in 5" :key="i" :style="getFloatStyle(i)"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StrategySection",
  methods: {
    getFloatStyle(index) {
      const positions = [
        { left: "10%", top: "20%", delay: 0 },
        { left: "80%", top: "15%", delay: 2 },
        { left: "15%", top: "70%", delay: 4 },
        { left: "75%", top: "65%", delay: 1 },
        { left: "50%", top: "50%", delay: 3 },
      ];
      const pos = positions[index - 1];
      return {
        left: pos.left,
        top: pos.top,
        animationDelay: `${pos.delay}s`,
      };
    },
  },
};
</script>

<style scoped>
.strategy-section {
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  position: relative;
  overflow: hidden;
  min-height: 500px;
}

.strategy-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(49, 148, 178, 0.05) 2px, rgba(49, 148, 178, 0.05) 4px);
  opacity: 0.3;
}

.strategy-content {
  position: relative;
  z-index: 10;
  max-width: 800px;
}

.strategy-content h2 {
  font-size: 42px;
  color: white;
  font-weight: 700;
  margin-bottom: 10px;
}

.strategy-title-en {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 30px;
}

.strategy-divider {
  width: 80px;
  height: 4px;
  background: white;
  margin-bottom: 30px;
  border-radius: 2px;
}

.strategy-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
  line-height: 2;
  font-weight: 300;
}

.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.float-item {
  position: absolute;
  width: 60px;
  height: 60px;
  border: 2px solid rgba(49, 148, 178, 0.25);
  border-radius: 12px;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-30px) rotate(180deg);
  }
}

@media (max-width: 768px) {
  .strategy-content h2 {
    font-size: 32px;
  }

  .strategy-text {
    font-size: 16px;
  }
}
</style>
